// extracted by mini-css-extract-plugin
export default {"avatar":"person-card_avatar__WFBrg","text":"person-card_text__fG4A2","content":"person-card_content__OOBaV","list":"person-card_list__N2v-J","card":"person-card_card__nhuB8"};